import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '⚡',
  title: 'Más energía diaria',
  description: 'Despierta sintiéndote renovado y mantén un nivel de energía constante durante todo el día.'
}, {
  emoji: '🌿',
  title: 'Mejor digestión',
  description: 'Adiós a la pesadez, gases e inflamación después de cada comida.'
}, {
  emoji: '⚖️',
  title: 'Peso saludable',
  description: 'Pierde esos kilos de más de forma natural y sin pasar hambre.'
}, {
  emoji: '💚',
  title: 'Hígado más sano',
  description: 'Reduce la grasa hepática y mejora tus resultados en los análisis de sangre.'
}, {
  emoji: '😋',
  title: 'Comidas deliciosas',
  description: 'Disfruta de platillos llenos de sabor que a toda tu familia le encantarán.'
}, {
  emoji: '⏱️',
  title: 'Ahorro de tiempo',
  description: 'Recetas rápidas de preparar para que no pases horas en la cocina.'
}];
export function Benefits() {
  return <section className="py-20 bg-brand-bg" data-id="element-3">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-5">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-6">
            Lo que lograrás con este recetario
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-7">
            Transforma tu cuerpo desde adentro hacia afuera con el poder de la
            alimentación correcta.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-8">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-primary/10 hover:border-brand-accent transition-colors group" data-id="element-9">
              <div className="w-14 h-14 bg-brand-primary/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-brand-accent/20 transition-colors group-hover:scale-110 duration-300" data-id="element-10">
                <span className="text-3xl leading-none" role="img" aria-hidden="true" data-id="element-11">
                  {benefit.emoji}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-12">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-13">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}